import { ComponentProps } from "react";

import { Step } from "../../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import NoToAllMedicalStep from "../Components/NoToAllMedicalStep";
import { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import AllMedicalQuestionsEvaluator from "./AllMedicalQuestionsEvaluator";
import { AllMedicalQuestions } from "./ComposedAllMedicalQuestions";
import ComposedUseCreateMedicalNonCanLeadResult from "./ComposedUseCreateMedicalNonCanLeadResult";

const ConfiguredNoToAllMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  NoToAllMedicalStep({
    ...props,
    nextStep: Step.scheduling,
    medicalQualificationEvaluator: AllMedicalQuestionsEvaluator,
    FormQuestions: AllMedicalQuestions,
    useCreateNonCandidateLeadResult: ComposedUseCreateMedicalNonCanLeadResult
  });

const ComposedNoToAllMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredNoToAllMedicalStep>
>({
  Component: ConfiguredNoToAllMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSaveCustomerNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSaveCustomerNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedNoToAllMedicalStep;
